var map = {
	"./ar/menu.json": 9493,
	"./cz/menu.json": 2207,
	"./de/menu.json": 6097,
	"./en/menu.json": 5125,
	"./fr/menu.json": 780,
	"./it/menu.json": 859,
	"./ja/menu.json": 7759,
	"./ko/menu.json": 5526,
	"./kz/menu.json": 5575,
	"./pt/menu.json": 8176,
	"./sk/menu.json": 1770,
	"./sv/menu.json": 7771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7043;